export default {
  save: "Save",
  cancel: "Cancel",
  create: "Create {{item}}",
  delete: "Delete {{item}}",
  deleteSimple: "Delete",
  require: "First configure your `{{item}}`",
  search: "Search",
}
